import { useLenis } from "lenis/react";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  const lenis = useLenis();

  const go = (id) => (e) => {
    e.preventDefault();
    lenis?.scrollTo(`#${id}`, { offset: -64, duration: 1.4 });
  };

  return (
    <footer data-testid="main-footer" className="bg-night py-16 text-ivory/60 md:py-20">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 border-b border-ivory/10 pb-14 md:grid-cols-3">
          <div>
            <img src="/logo-full.png" alt="Élite Service — Golfo del Tigullio" className="h-36 w-auto" />
            <p className="mt-6 max-w-xs text-sm font-light leading-relaxed">{t.footer.tagline}</p>
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-champagne">{t.footer.navTitle}</p>
            <nav className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {(t.nav.links || []).map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  onClick={go(l.id)}
                  data-testid={`footer-link-${l.id}`}
                  className="text-sm font-light transition-colors duration-300 hover:text-champagne"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-champagne">{t.footer.contactTitle}</p>
            <p className="mt-5 text-sm font-light leading-relaxed">
              {t.contact.address}
              <br />
              {t.contact.phone}
              <br />
              {t.contact.email}
            </p>
          </div>
        </div>
        <p className="pt-8 text-[11px] font-light leading-relaxed tracking-wide text-ivory/35" data-testid="footer-keywords">
          {t.footer.keywords}
        </p>
        <div className="mt-6 flex flex-col gap-2 text-[11px] font-light tracking-wide text-ivory/35 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Élite Service — {t.footer.rights}</span>
          <span>{t.footer.vat}</span>
        </div>
      </div>
    </footer>
  );
}
